<template>
  <div class="videoList">
    <SectionTitleBar :sectionLinks="availableViews" :buttonText="showFilter? 'Filter' : null" v-on:buttonPress="toggleFilterForm"/>
    <FilterForm :elementName="'videoFilterForm'" v-if="elementVisibility['videoFilterForm']" />
    <SmallTagGroup :tags="activeFilters" v-on:closeButton="removeFilter($event)" />
    <template v-if="selectedView == 'thumbnails'">
      <VideoGroup v-for="(videoGroup, index) in filteredVideos" :showGroupName="showGroupName" :videoList="videoGroup.videos" :name="videoGroup.name" :key="index"/>
    </template>
    <template v-if="selectedView == 'table'">
      <table class="adminUserTable" >
        <thead>
          <tr>
            <th v-for="field in fields" :key="field.key">{{field.label}}</th>
          </tr>
        </thead>
        <template v-for="(videoGroup, index) in filteredVideos">
          <thead :key="'head' + index" v-if="showGroupName">
            <tr>
              <th class="groupName" colspan="100%">{{videoGroup.name}}</th>
            </tr>
          </thead>

          <tbody :key="'body' + index">
            <FirebaseRow v-for="video in videoGroup.videos" :record="video" :fields="fields" :key="video.id" :collection="'deliverables'"/>
          </tbody>
        </template>
      </table>
    </template>
    <template v-if="selectedView == 'queue'">
      <VideoQueue :videoGroups="filteredVideos"/>
    </template>
  </div>
</template>

<script>
import FilterForm from '../components/FilterForm.vue'
import SmallTagGroup from '../components/ui/SmallTagGroup.vue'
import VideoGroup from '../components/VideoGroup.vue'
import SectionTitleBar from '../components/SectionTitleBar.vue'
import FirebaseRow from '../components/FirebaseRow.vue'
import VideoQueue from '../components/VideoQueue.vue'

export default {
  name: 'videoGrid',
  components: {
    FilterForm,
    SmallTagGroup,
    VideoGroup,
    SectionTitleBar,
    FirebaseRow,
    VideoQueue
  },
  data () {
    return {
      selectedView: "thumbnails",
      showFilter: true,
      viewLinks: {
        "thumbnails": {
          "name": "Thumbnails",
          "admin": false,
          "defaultTransform": {
            "groupby": "batch",
            "sort":{
              "field": "batchRank",
              "direction": 1
            },
            "filters": []
          }
        },
        "table":{
          "name": "Table",
          "admin": true,
          "defaultTransform": {
            "groupby": "batch",
            "sort":{
              "field": "batchRank",
              "direction": 1
            },
            "filters": []
          }
        },
        "queue":{
          "name": "Creative Queue",
          "admin": true,
          "hideFilter": true,
          "forceTransform": true,
          "defaultTransform": {
            "groupby": "batch",
            "sort":{
              "field": "batchRank",
              "direction": 1
            },
            "filters": []
          }
        }
      }
    }
  },
  created: function(){
    if (this.$route.query.view && this.selectedView != this.$route.query.view) {
      this.selectedView = this.$route.query.view
      this.$store.commit('updateDeliverableTransform', this.viewLinks[this.selectedView].defaultTransform)
      if (this.viewLinks[this.selectedView].hideFilter) {
        this.showFilter = false
      } else {
        this.showFilter = true
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.query.view && this.selectedView != to.query.view) {
      this.selectedView = to.query.view
      this.$store.commit('updateDeliverableTransform', this.viewLinks[this.selectedView].defaultTransform)
      if (this.viewLinks[this.selectedView].hideFilter) {
        this.showFilter = false
      } else {
        this.showFilter = true
      }
    }
    next()
  },
  computed: {
    showGroupName(){
      if (this.filteredVideos.length > 1) {
        return true
      } else {
        return false
      }
    },
    activeFilters(){
      return this.$store.getters.videoFilterList
    },
    filteredVideos () {
      return this.$store.getters.getFilteredVideos;
    },
    elementVisibility() {
      return this.$store.state.elementVisibility
    },
    availableViews(){
      var visibleViews = []
      var existingRoute = this.$route
      var selectedView = this.selectedView
      var viewLinks = this.viewLinks
      Object.keys(this.viewLinks).forEach((linkKey) => {
        if (!viewLinks[linkKey].admin || this.$store.getters.isAdmin) {
          var linkRoute = {
            ...existingRoute,
            query: {
              ...existingRoute.query,
              view: linkKey
            }
          }
          visibleViews.push({
            ...viewLinks[linkKey],
            route: linkRoute,
            selected: (selectedView === linkKey)
          })
        }
      })
      return visibleViews
    },
    fields () {
      return [
        {
          "label": "Delivery Code",
          "key": "deliveryCode",
          "type": "String",
          "editable": false
        },
        {
          "label": "Number",
          "key": "number",
          "type": "Number",
          "editable": true
        },
        {
          "label": "CTR",
          "key": "performance.lifetime.ctr",
          "type": "Percentage",
          "editable": false
        },
        {
          "label": "Direction",
          "key": "direction",
          "type": "Reference",
          "editable": true
        },
        {
          "label": "Batch",
          "key": "batch",
          "type": "Reference",
          "editable": true
        },
        {
          "label": "License",
          "key": "licensing.complete",
          "type": "Boolean",
          "editable": true
        },
        {
          "label": "No License Needed",
          "key": "licensing.noneRequired",
          "type": "Boolean",
          "editable": true
        },
        {
          "label": "Delivery Date",
          "key": "deliveryDate",
          "type": "Date",
          "editable": true
        }
      ]
    }
  },
  watch: {
    '$store.state.selectedClient': function() {
      this.$store.dispatch('fetchVideos');
    }
  },
  methods: {
    removeFilter(filterID){
      this.$store.commit('removeDeliverableFilter',filterID);
    },
    toggleFilterForm(){
      this.$store.commit('toggleVisibility','videoFilterForm')
    }
  }
}
</script>

<style>
  .videoList {
    width: 100%;
  }
  .groupName {
    text-align: center;
  }
  .videoList {
    width: 100%;
    height: 100%;
  }
  .adminUserTable {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
  }
  td {
    border: 2px solid #2E303A;
  }
  td, th {
    padding: 15px;
  }
</style>
